import { render, staticRenderFns } from "./instructionProofUpload.vue?vue&type=template&id=2366834e"
import script from "./instructionProofUpload.vue?vue&type=script&lang=js"
export * from "./instructionProofUpload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports